/** Supported languages for the v2 portal (isolated copy — no v1 import). */
export enum Language {
  Ar = 'ar',
  En = 'en',
}

export type TextDirection = 'rtl' | 'ltr';

export const DEFAULT_LANGUAGE: Language = Language.Ar;

export interface LanguageDescriptor {
  code: Language;
  name: string;
  nativeName: string;
  direction: TextDirection;
}

export const AVAILABLE_LANGUAGES: readonly LanguageDescriptor[] = [
  { code: Language.Ar, name: 'Arabic', nativeName: 'العربية', direction: 'rtl' },
  { code: Language.En, name: 'English', nativeName: 'English', direction: 'ltr' },
] as const;

/** Resolve the writing direction for a language. */
export function directionOf(lang: Language): TextDirection {
  return lang === Language.Ar ? 'rtl' : 'ltr';
}

/** Narrow an arbitrary string to a supported Language, falling back to default. */
export function toLanguage(value: string | null | undefined): Language {
  return value === Language.En ? Language.En : value === Language.Ar ? Language.Ar : DEFAULT_LANGUAGE;
}

/** The "other" language — used for fallback resolution. */
export function fallbackLanguageOf(lang: Language): Language {
  return lang === Language.Ar ? Language.En : Language.Ar;
}
